import { render, staticRenderFns } from "./Misnomers.vue?vue&type=template&id=4569dcb6"
import script from "./Misnomers.vue?vue&type=script&lang=js"
export * from "./Misnomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports